import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {fetchAccounts, deleteAccount, closeAlert} from '../actions/account'
import {logout} from '../actions/user'
import Account from '../components/Account';
import {changeFilterDatas} from '../actions/filter'


const mapStateToProps = state => {
  const { account } = state
  const {
    isFetching,
    lastUpdated,
    items,
    deletedId,
    openAlert,
    deleteSuccess,
    requestAccountFail
  } = account || {
    isFetching: true,
    items: [],
    deletedId: -1
  }

  return {
    items,
    isFetching,
    lastUpdated,
    deletedId,
    openAlert,
    deleteSuccess,
    requestAccountFail
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAccounts: fetchAccounts,
      deleteAccount,
      onCloseAlert: closeAlert,
      changeFilterDatas:changeFilterDatas,
      logout,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Account)
